export default "__VITE_ASSET__Dq3sUo91__"